import { atom } from "recoil";
import { PolicyTermType } from "../../types";

export const addStatePolicyTerm = atom({
  key: "addStatePolicyTerm",
  default: false,
});
export const editStatePolicyTerm = atom({
  key: "editStatePolicyTerm",
  default: false,
});

export const disableButtonStatePolicyTerm = atom({
  key: "disableButtonStatePolicyTerm",
  default: false,
});

export const selectedRowsStatePolicyTerm = atom<Pick<PolicyTermType, "policyTermId">[] | []>({
  key: "selectedRowsStatePolicyTerm",
  default: [],
});

export const setFilterTextPolicyTerm = atom({
  key: "setFilterTextPolicyTerm",
  default: "",
});

export const rowEditIdStatePolicyTerm = atom<PolicyTermType | null>({
  key: "rowEditIdStatePolicyTerm",
  default: {
    policyTermId: 0,
    policyTermName: "",
    createdBy: "",
    createdDate: new Date,
    modifiedBy: "",
    modifiedDate: new Date,
    polTerm: 0,
    isActive: true
  }
});

export const policyTermSaving = atom({
  key: "policyTermSaving",
  default: false,
});